// extracted by mini-css-extract-plugin
module.exports = {"edit-action":"EditAction_edit-action__3kWqz"};